import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { mobile, tablet } from '~styles/global'
import Layout from '~components/layout'
import Section from '~components/global/section'
import Button from '~components/global/button'
import { Incrementer } from "~components/global/formElements"
import Recommendation from '~components/quiz/recommendation'

export const TagLine = styled.h5`
  margin-bottom: 0.5rem;
`
export const ItalicTagLine = styled(TagLine)`
  font-style: italic;
`

export const Headline = styled.h2`
  margin-bottom: 3rem;
  ${tablet}{
    max-width: 660px;
  }
`

export const Input = styled.input`
  border: none;
  border-radius: 10px;
  height: 50px;
  text-align: center;
  width: 100%;
  max-width: 580px;
  ::placeholder{
    color: #000;
    font-family: inherit;
  }
`
export const Buttons = styled.div`
  grid-column: 1/13;
  margin-bottom: 6rem;
  align-self: end;
  grid-row: 2;
  position: relative;
  z-index: 2;
  ${tablet}{
    grid-column: 2/6;
  }
  ${mobile}{
    grid-column: 1/7;
    margin-bottom: 0rem;
  }
`
export const Next = styled(Button)`
  opacity: ${props => props.disabled ? '0.5' : '1'};
  pointer-events: ${props => props.disabled ? 'none' : 'all'};
  padding: 0 40px 0 30px;
  margin-bottom: 10px;
  min-width: 174px;
  color: #fff;
  border-color: #EC873E;
  background: #EC873E;
  > i {
    background: #fff;
    color: #000;
  }
  :hover, :focus{
    color: #EC873E;
    border-color: #EC873E;
    background: #ffffff;
    > i {
      background: #EC873E;
      color: #ffffff;
    }
  }
`
export const Back = styled(Next)`
  opacity: ${props => props.disabled ? '0.5' : '1'};
  pointer-events: ${props => props.disabled ? 'none' : 'all'};
  margin-right: 0.8rem;
  padding: 0 30px 0 40px;
  color: #EC873E;
  border-color: #EC873E;
  background: #ffffff;
  > i {
    left: 4px;
    transform: rotate(180deg);
    background: #EC873E;
    color: #fff;
  }
  :hover, :focus{
    color: #fff;
    border-color: #EC873E;
    background: #EC873E;
    > i {
      background: #fff;
      color: #000;
    }
  }
  ${tablet}{
    text-align: right;
  }
`
export const Levels = styled.div`
  background-color: #FFF1E2;
`
export const LevelBlock = styled(Section)`
  
`
export const LevelWrap = styled(Section)`
  > div {
    text-align: center;
    min-height: calc(100vh - 120px); 
    align-items: center;
    grid-template-rows: 1fr max-content;
    ${mobile}{
      min-height: calc(100vh - 80px);
    }
  }
`
export const Container = styled.div`
  grid-column: 4/10;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  ${tablet}{
    grid-column: 2/6;
  }
  ${mobile}{
    grid-column: 1/7;
  }
`
export const Top = styled(Container)`
  grid-row: 1;
  grid-column: 1/13;
  max-width: 930px;
  margin: 3rem auto 0;
  position: relative;
  z-index: 2;
  ${tablet}{
    grid-column: span 6;
  }
`
export const IncrementerBlock = styled.div`
`
export const StyledIncrementer = styled(Incrementer)`
  min-width: 250px;
  > input {
    border: 1px solid #000;
    background-color: transparent;
  }
  button {
    background: #000;
    border-radius: 100px;
    color: #fff;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    > svg {
      width: 21px;
      height: 21px;
    }
  }
`
export const Tiles = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 0 1rem; 
  max-width: 680px;
  ${tablet}{
    grid-column: 2/6;
    margin: 0 0 1rem;
  }
  ${mobile}{
    grid-column: 1/7;
    grid-template-columns: 1fr;
  }
`
export const StyledTile = styled.button`
  width: ${props => props.rowOfFour ? 'calc(25% - 40px)' : 'calc(33.33% - 40px)'};
  border-radius: 10px;
  background-color: ${props => props.inverse ? '#4B3043' : '#fff'};
  color: ${props => props.inverse ? '#fff' : '#000'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  text-align: center;
  transition: background-color 0.2s, color 0.2s;
  margin: 0 20px 40px;
  ${mobile}{
    width: 100%;
    margin: 0 10px 30px;
    align-items: center;
  }
`
export const TileHeading = styled.div`
`
export const TileText = styled.div`
  font-style: italic;
`
export const RightImageBlock = styled.div`
  display: ${props => props.show ? 'block' : 'none'};  
  grid-column: 1/13;
  grid-row: 1/3;
  align-self: end;
  justify-self: end;
  max-width: 330px;
  margin-bottom: 6rem;
  position: relative;
  z-index: 1;
  ${tablet}{
    display: none;
  }
`
export const LeftImageBlock = styled.div`
  display: ${props => props.show ? 'block' : 'none'};
  grid-column: 1/13;
  grid-row: 1/3;
  align-self: end;
  justify-self: start;
  max-width: 330px;
  margin-bottom: 6rem;
  position: relative;
  z-index: 1;
  ${tablet}{
    display: none;
  }
`
export const LeftImage = styled.img`
  
`
export const RightImage = styled.img`
`

export const ImageMobBlock = styled.div`
  display: none;
  grid-column: span 6;
  max-width: 300px;
  margin: 0 auto;
  ${mobile}{
    display: block;
  }
`

export const ImageMob = styled.img`
  width: 100%;
`

export const DisabledMessage = styled.div`
  color: rgb(219, 129, 6);
  width: 100%;
  margin-bottom: 1rem;
  text-align: center;
  opacity: ${props => props.show ? '1' : '0'};
`